import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-footer-four',
  templateUrl: './footer-four.component.html',
  styleUrls: ['./footer-four.component.scss']
})
export class FooterFourComponent implements OnInit {

  @Input() class: string = 'footer-light' // Default class 
  // @Input() themeLogo: string ='https://izzimoviles.s3.us-east-1.amazonaws.com/Imagenes/GIGMAX_WHITE.png'; // Default Logo
  @Input() themeLogo: string = 'assets/images/icon/logo_gigmax.webp'; //'assets/images/icon/logo_bt_white.png'; // Default Logo

  public today: number = Date.now();
  
  constructor() { }

  ngOnInit(): void {
  }

}
